import CategoryBar from './CategoryBar';
export default CategoryBar;
